import { Helmet } from 'react-helmet-async'
import { PrintMenuBook } from '@/components/printMenu/PrintMenuBook'
import { site } from '@/content/site'

export default function PrintMenuPage() {
  return (
    <>
      <Helmet>
        <title>Print Menu Preview | {site.name}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <PrintMenuBook />
    </>
  )
}
